import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';

// Páginas
import LoginPage from './pages/auth/LoginPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import Dashboard from './pages/dashboard/Dashboard';
import EventsPage from './pages/dashboard/EventsPage';
import EventsCalendar from './pages/dashboard/EventsCalendar';
import ExpositorHomePage from './pages/expositor/ExpositorHomePage';
import CatalogPage from './pages/catalog/CatalogPage';
import NewOrderPage from './pages/catalog/NewOrderPage';
// Importando a nova página de lista de pedidos
import OrdersList from './pages/orders';
import OrderDetailsPage from './components/orders/OrderDetailsPage';
import ItensPedidoPage from './components/orders/ItensPedidoPage';
import ProductManagement from './pages/admin/ProductManagement';
import CategoryManagement from './pages/admin/CategoryManagement'; // Importando o novo componente
import ExhibitorManagement from './pages/admin/ExhibitorManagement';
import OrdersApproval from './pages/admin/OrdersApproval';
import EventManagement from './pages/admin/EventManagement';
import GestaoMaterialApoio from './pages/admin/GestaoMaterialApoio';
import ItensPedidoComponent from './components/orders/ItensPedidoComponent';
// NOVA IMPORTAÇÃO: Página de Pedidos no Carrinho
import PedidosCarrinho from './pages/admin/PedidosCarrinho';

// Páginas de Montadoras e Montadores
import EmpresasMontadoras from './pages/montadoras/EmpresasMontadoras';
import Montadores from './pages/montadoras/Montadores';
import ControleAcesso from './pages/montadoras/ControleAcesso';

// Páginas de Credenciais Expositor
import CadastroCredenciais from './pages/credenciais/CadastroCredenciais';
// NOVA IMPORTAÇÃO
import CredencialPrestador from './pages/credenciais/CredencialPrestador';

// Nova página de Acessos
import Acessos from './pages/acessos/Acessos';

// Páginas de Material de Apoio
import PlantaEvento from './pages/materialApoio/PlantaEvento';
import ManualExpositor from './pages/materialApoio/ManualExpositor';

// NOVA IMPORTAÇÃO: Página de Relatórios
import Relatorios from './pages/relatorios/Relatorios';

// Componentes
import ProtectedRoute, { AdminRoute, ExpositorRoute } from './components/auth/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';

// Componente para redirecionamento inteligente baseado no perfil do usuário
const HomeRedirect = () => {
  const { hasRole } = useAuth();
  
  // Redireciona admin para dashboard e expositor para sua página inicial
  if (hasRole('admin')) {
    return <Navigate to="/dashboard" replace />;
  } else {
    return <Navigate to="/expositor-home" replace />;
  }
};
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular carregamento inicial
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-content">
          <h2>MM Eventos</h2>
          <p>Carregando o sistema...</p>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        
        {/* Rotas protegidas */}
        <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          {/* Tela inicial do Expositor */}
          <Route path="/expositor-home" element={<ExpositorRoute><ExpositorHomePage /></ExpositorRoute>} />
          
          {/* Dashboard - apenas para admin */}
          <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/dashboard/events" element={<AdminRoute><EventsPage /></AdminRoute>} />
          <Route path="/dashboard/events/calendar" element={<AdminRoute><EventsCalendar /></AdminRoute>} />
          
          {/* Catálogo */}
          <Route path="/catalog" element={<ExpositorRoute><CatalogPage /></ExpositorRoute>} />
          <Route path="/catalog/new-order" element={<ExpositorRoute><NewOrderPage /></ExpositorRoute>} />
          
          {/* Pedidos */}
          {/* Nova rota para lista de pedidos do expositor */}
          <Route path="/orders" element={<ExpositorRoute><OrdersList /></ExpositorRoute>} />
          
          {/* Novas rotas para as páginas de pedidos aprimoradas */}
          <Route path="/orders/details/:id" element={<ExpositorRoute><OrderDetailsPage /></ExpositorRoute>} />
          <Route path="/orders/items" element={<ExpositorRoute><ItensPedidoPage /></ExpositorRoute>} />
          <Route path="/orders/items/:id" element={<ExpositorRoute><ItensPedidoPage /></ExpositorRoute>} />
          
          {/* Material de Apoio */}
          <Route path="/material-apoio/planta" element={<ExpositorRoute><PlantaEvento /></ExpositorRoute>} />
          <Route path="/material-apoio/manual" element={<ExpositorRoute><ManualExpositor /></ExpositorRoute>} />
          
          {/* Montadoras e Montadores */}
          <Route path="/montadoras/empresas" element={<ExpositorRoute><EmpresasMontadoras /></ExpositorRoute>} />
          <Route path="/montadoras/montadores" element={<ExpositorRoute><Montadores /></ExpositorRoute>} />
          
          {/* Controle de Acesso (agora como AdminRoute) */}
          <Route path="/controle-acesso" element={<AdminRoute><ControleAcesso /></AdminRoute>} />
          
          {/* Nova rota para Acessos - apenas para admin */}
          <Route path="/acessos" element={<AdminRoute><Acessos /></AdminRoute>} />
          
          {/* Credenciais */}
          <Route path="/credenciais-expositor/cadastro" element={<ExpositorRoute><CadastroCredenciais /></ExpositorRoute>} />
          {/* NOVA ROTA ADICIONADA */}
          <Route path="/credenciais/prestador" element={<ExpositorRoute><CredencialPrestador /></ExpositorRoute>} />

          {/* NOVA ROTA: Relatórios - disponível para admin e expositor */}
          <Route path="/relatorios" element={<ProtectedRoute><Relatorios /></ProtectedRoute>} />
          
          {/* Admin */}
          <Route path="/admin/products" element={<AdminRoute><ProductManagement /></AdminRoute>} />
          {/* Nova rota para Categorias de Produtos */}
          <Route path="/admin/categories" element={<AdminRoute><CategoryManagement /></AdminRoute>} />
          <Route path="/admin/exhibitors" element={<AdminRoute><ExhibitorManagement /></AdminRoute>} />
          <Route path="/admin/orders" element={<AdminRoute><OrdersApproval /></AdminRoute>} />
          {/* NOVA ROTA: Pedidos no Carrinho - apenas para admin */}
          <Route path="/admin/pedidos-carrinho" element={<AdminRoute><PedidosCarrinho /></AdminRoute>} />
          <Route path="/admin/events" element={<AdminRoute><EventManagement /></AdminRoute>} />
          {/* Nova rota para Gestão de Materiais de Apoio */}
          <Route path="/admin/materiais-apoio" element={<AdminRoute><GestaoMaterialApoio /></AdminRoute>} />
          
          {/* Redirecionar para a página inicial adequada com base no perfil */}
          <Route path="/" element={<HomeRedirect />} />
        </Route>
        
        {/* Rota 404 - redireciona para login se não autenticado */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;